<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex md6 offset-md3 xs12>
        <v-container grid-list-xs xs6>
          <div v-if="loading" class="text-center pa-4">
            <v-progress-circular indeterminate color="primary" />
            <p class="mt-2">Loading match…</p>
          </div>
          <template v-else-if="match && wrestler1 && wrestler2">
            <div class="match-results-page">
              <v-card class="match-results-card rounded-card">
                <v-toolbar color="red" dark class="match-results-toolbar">
                  <v-toolbar-title class="match-results-title"
                    >Match Results Between</v-toolbar-title
                  >
                </v-toolbar>
                <div class="match-wrestlers">
                  <button
                    type="button"
                    class="match-wrestler match-wrestler-1"
                    @click="LoadWrestler($route.params.wrestlerID)"
                  >
                    <v-avatar size="56" class="match-wrestler-avatar">
                      <img
                        v-if="authenticated && wrestler1.Image"
                        :src="wrestler1.Image"
                        alt=""
                      />
                      <img
                        v-else
                        :src="require('../assets/default-profile.png')"
                        alt=""
                      />
                    </v-avatar>
                    <span class="match-wrestler-name">
                      {{ wrestler1.FirstName }} {{ wrestler1.LastName }}
                    </span>
                    <div class="match-wrestler-rating">
                      <div
                        class="skill-bar skill-bar--match skill-bar--linear"
                        :aria-label="'Skill rating ' + displaySkillAfterMatch1"
                      >
                        <div class="skill-bar-linear-track">
                          <div
                            class="skill-bar-linear-fill"
                            :style="{
                              width: skillBarLinearWidthPercent1 + '%',
                            }"
                          ></div>
                        </div>
                        <span class="skill-bar-label">{{
                          displaySkillAfterMatch1
                        }}</span>
                      </div>
                    </div>
                  </button>
                  <span class="match-vs" aria-hidden="true">vs</span>
                  <button
                    type="button"
                    class="match-wrestler match-wrestler-2"
                    @click="LoadWrestler(match.WrestlerID)"
                  >
                    <v-avatar size="56" class="match-wrestler-avatar">
                      <img
                        v-if="authenticated && wrestler2.Image"
                        :src="wrestler2.Image"
                        alt=""
                      />
                      <img
                        v-else
                        :src="require('../assets/default-profile.png')"
                        alt=""
                      />
                    </v-avatar>
                    <span class="match-wrestler-name">
                      {{ wrestler2.FirstName }} {{ wrestler2.LastName }}
                    </span>
                    <div class="match-wrestler-rating">
                      <div
                        class="skill-bar skill-bar--match skill-bar--linear"
                        :aria-label="'Skill rating ' + displaySkillAfterMatch2"
                      >
                        <div class="skill-bar-linear-track">
                          <div
                            class="skill-bar-linear-fill"
                            :style="{
                              width: skillBarLinearWidthPercent2 + '%',
                            }"
                          ></div>
                        </div>
                        <span class="skill-bar-label">{{
                          displaySkillAfterMatch2
                        }}</span>
                      </div>
                    </div>
                  </button>
                </div>
              </v-card>

              <v-card class="match-details-card rounded-card">
                <div class="match-details-inner">
                  <div class="match-detail-row">
                    <span class="match-detail-label">Winner</span>
                    <span class="match-detail-value">
                      <template v-if="match.Result === 'Win'">
                        {{ wrestler1.FirstName }} {{ wrestler1.LastName }}
                      </template>
                      <template v-else>
                        {{ wrestler2.FirstName }} {{ wrestler2.LastName }}
                      </template>
                    </span>
                  </div>
                  <div class="match-detail-row">
                    <span class="match-detail-label">Event</span>
                    <span class="match-detail-value">{{
                      match.Location || "—"
                    }}</span>
                  </div>
                  <div class="match-detail-row">
                    <span class="match-detail-label">Date</span>
                    <span class="match-detail-value">{{
                      formatMatchDate(match.MatchDate)
                    }}</span>
                  </div>
                  <div class="match-detail-row">
                    <span class="match-detail-label">Type</span>
                    <span class="match-detail-value">{{
                      match.Type || "—"
                    }}</span>
                  </div>
                  <div
                    v-if="displaySeason(match.Season)"
                    class="match-detail-row"
                  >
                    <span class="match-detail-label">Season</span>
                    <span class="match-detail-value">{{
                      displaySeason(match.Season)
                    }}</span>
                  </div>
                  <div
                    v-if="
                      (skillDeltaForWrestler1 != null &&
                        skillDeltaForWrestler1 !== 0) ||
                      (skillDeltaForWrestler2 != null &&
                        skillDeltaForWrestler2 !== 0)
                    "
                    class="match-detail-row match-detail-row--skill"
                  >
                    <span class="match-detail-label">Skill change</span>
                    <div class="match-detail-value match-skill-pair">
                      <span
                        v-if="skillDeltaForWrestler1 != null"
                        class="match-skill-pair-item"
                      >
                        {{ wrestler1.FirstName }} {{ wrestler1.LastName }}:
                        <span
                          :class="skillDeltaClass(skillDeltaForWrestler1)"
                          >{{ formatSkillDelta(skillDeltaForWrestler1) }}</span
                        >
                      </span>
                      <span
                        v-if="
                          skillDeltaForWrestler1 != null &&
                          skillDeltaForWrestler2 != null
                        "
                        class="match-skill-pair-sep"
                        aria-hidden="true"
                        >·</span
                      >
                      <span
                        v-if="skillDeltaForWrestler2 != null"
                        class="match-skill-pair-item"
                      >
                        {{ wrestler2.FirstName }} {{ wrestler2.LastName }}:
                        <span
                          :class="skillDeltaClass(skillDeltaForWrestler2)"
                          >{{ formatSkillDelta(skillDeltaForWrestler2) }}</span
                        >
                      </span>
                    </div>
                  </div>
                  <div class="match-detail-row">
                    <span class="match-detail-label">Video</span>
                    <span class="match-detail-value">
                      <a
                        v-if="match.VideoLink && match.VideoLink.trim() !== ''"
                        :href="normalizeVideoUrl(match.VideoLink)"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="match-video-link"
                        @click.stop
                        >Watch video</a
                      >
                      <span v-else>—</span>
                    </span>
                  </div>
                </div>
              </v-card>

              <v-card
                v-if="authenticated"
                class="match-history-card rounded-card"
              >
                <div class="match-history-header">Match Change History</div>
                <div class="match-history-body">
                  <div
                    v-for="a in audits"
                    :key="a.id"
                    class="match-history-item"
                  >
                    <div class="match-history-item-title">
                      <v-chip
                        :color="getActionColor(a.action)"
                        text-color="white"
                        small
                        class="match-history-chip"
                      >
                        {{ a.action }}
                      </v-chip>
                      {{ a.userName || "System" }}
                    </div>
                    <div class="match-history-item-subtitle">
                      {{ formatAuditDate(a.timestamp) }}
                      <span
                        v-if="a.changes && Object.keys(a.changes).length > 0"
                        class="match-history-changes"
                      >
                        {{ getChangesPreview(a.changes) }}
                      </span>
                    </div>
                  </div>
                  <div
                    v-if="!audits || audits.length === 0"
                    class="match-history-empty"
                  >
                    No changes recorded yet
                  </div>
                </div>
              </v-card>
            </div>

            <FloatingNav>
              <template v-slot:extra>
                <v-list-tile
                  v-if="authenticated"
                  @click="
                    openEdit();
                    $root.$emit('close-fab-menu');
                  "
                >
                  <v-list-tile-avatar>
                    <v-icon>edit</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>Edit match</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile
                  v-if="authenticated"
                  @click="
                    openDeleteDialog();
                    $root.$emit('close-fab-menu');
                  "
                >
                  <v-list-tile-avatar>
                    <v-icon>delete</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>Delete match</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile
                  :aria-label="$root.darkMode ? 'Light mode' : 'Dark mode'"
                  @click="
                    $root.toggleDarkMode && $root.toggleDarkMode();
                    $root.$emit('close-fab-menu');
                  "
                >
                  <v-list-tile-avatar>
                    <v-icon>{{
                      $root.darkMode ? "brightness_5" : "brightness_3"
                    }}</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>{{
                      $root.darkMode ? "Light mode" : "Dark mode"
                    }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </FloatingNav>

            <v-dialog
              v-model="editDialog"
              max-width="520px"
              content-class="edit-match-dialog"
              persistent
            >
              <v-card class="edit-match-card">
                <div class="edit-match-header">
                  <h2 class="edit-match-title">Edit match</h2>
                  <v-btn
                    icon
                    dark
                    class="edit-match-close"
                    @click="editDialog = false"
                  >
                    <v-icon>close</v-icon>
                  </v-btn>
                </div>
                <v-card-text class="edit-match-body">
                  <div class="edit-match-form">
                    <div class="form-row form-row-split">
                      <div class="form-row-cell">
                        <v-select
                          v-model="editForm.Type"
                          :items="WinTypes"
                          label="Type"
                          outline
                          hide-details
                          class="form-field"
                        />
                      </div>
                      <div class="form-row-cell">
                        <v-text-field
                          v-model="editForm.MatchDateString"
                          type="date"
                          label="Match date"
                          outline
                          hide-details
                          class="form-field"
                        />
                      </div>
                    </div>
                    <div class="form-row">
                      <v-text-field
                        v-model="editForm.Location"
                        label="Location / Event"
                        outline
                        hide-details
                        class="form-field"
                      />
                    </div>
                    <div class="form-row">
                      <v-text-field
                        v-model="editForm.VideoLink"
                        label="Video URL"
                        outline
                        hide-details
                        class="form-field"
                      />
                    </div>
                    <div class="form-row">
                      <v-text-field
                        v-model="editForm.Season"
                        label="Season (from match date)"
                        placeholder="2025-26"
                        readonly
                        outline
                        hide-details
                        class="form-field"
                      />
                    </div>
                  </div>
                </v-card-text>
                <v-card-actions class="edit-match-actions">
                  <v-btn
                    flat
                    class="action-btn action-cancel"
                    @click="editDialog = false"
                    >Cancel</v-btn
                  >
                  <v-spacer />
                  <v-btn
                    color="primary"
                    class="action-btn action-save"
                    @click="saveMatchEdits"
                    >Save</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="deleteDialog" max-width="400px">
              <v-card>
                <v-card-title class="headline"> Delete match? </v-card-title>
                <v-card-text>
                  Are you sure you want to delete this match? This action cannot
                  be undone.
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn flat @click="deleteDialog = false">Cancel</v-btn>
                  <v-btn color="red" flat @click="deleteMatch">Delete</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
          <div
            v-else-if="!loading && (!match || !wrestler1 || !wrestler2)"
            class="text-center pa-4"
          >
            <p>Match not found.</p>
            <v-btn flat color="primary" @click="goBack">Go back</v-btn>
          </div>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { getAuth, signOut } from "firebase/auth";
import { authState } from "../utils/authState";
import {
  getFirestore,
  doc,
  getDoc,
  updateDoc,
  deleteDoc,
  setDoc,
  Timestamp,
} from "firebase/firestore";
import { logAuditEntry } from "../utils/auditLog";
import { saveRankingsSnapshotForAthletes } from "../utils/rankingsSnapshot";
import {
  fetchLeagueSkillMinMax,
  skillBarLinearFillPercent as linearSkillBarFillPercent,
  computeEffectiveSkillBarRange,
} from "../utils/skillBarLinear";
import FloatingNav from "./FloatingNav.vue";
import {
  seasonLabelFromMatchDate,
  normalizeSeasonToShort,
} from "../utils/seasonFilter";
import {
  formatSkillLevel,
  formatSkillDeltaPoints,
} from "../utils/formatSkillDisplay";
import {
  MATCHES_CANONICAL_COLLECTION,
  perspectiveFromCanonical,
  fetchPerspectiveMatchesChronological,
  countWinsLossesFromCanonical,
  computeCanonicalMatchDocId,
  participantAthleteIds,
  matchDateMillis,
} from "../utils/canonicalMatches";

export default {
  components: { FloatingNav },
  data: () => ({
    match: null,
    wrestler1: null,
    wrestler2: null,
    showmatch: false,
    loading: true,
    editDialog: false,
    deleteDialog: false,
    editForm: {
      Location: "",
      Type: "",
      MatchDateString: "",
      VideoLink: "",
      Season: "",
    },
    async markAthletesForRecalc(id1, id2) {
      try {
        const db = getFirestore();
        if (id1) {
          await updateDoc(doc(db, "athletes", id1), { NeedsSkillRecalc: true });
        }
        if (id2) {
          await updateDoc(doc(db, "athletes", id2), { NeedsSkillRecalc: true });
        }
      } catch (_e) {
        // non-fatal
      }
    },
    WinTypes: [
      "Decision",
      "Major",
      "Technical Fall",
      "Fall",
      "Disqualification",
      "Forfeit",
      "Injury Default",
    ],
    audits: [],
    skillChangeWrestler2: null,
    opponentMatchDocId: null,
    canonicalRaw: null,
    skillRatingAfterMatch1: null,
    skillRatingAfterMatch2: null,
    matchLeagueSkillMin: null,
    matchLeagueSkillMax: null,
  }),
  computed: {
    authenticated() {
      return authState.user != null;
    },
    skillAfterMatchNumeric1() {
      if (typeof this.skillRatingAfterMatch1 === "number") {
        return this.skillRatingAfterMatch1;
      }
      return this.parseSkillNumber(this.wrestler1 && this.wrestler1.Skill);
    },
    skillAfterMatchNumeric2() {
      if (typeof this.skillRatingAfterMatch2 === "number") {
        return this.skillRatingAfterMatch2;
      }
      return this.parseSkillNumber(this.wrestler2 && this.wrestler2.Skill);
    },
    displaySkillAfterMatch1() {
      return formatSkillLevel(this.skillAfterMatchNumeric1);
    },
    displaySkillAfterMatch2() {
      return formatSkillLevel(this.skillAfterMatchNumeric2);
    },
    matchSkillBarRange() {
      return computeEffectiveSkillBarRange(
        this.matchLeagueSkillMin,
        this.matchLeagueSkillMax,
        this.skillAfterMatchNumeric1,
        this.skillAfterMatchNumeric2
      );
    },
    skillBarLinearWidthPercent1() {
      const { low, high } = this.matchSkillBarRange;
      return linearSkillBarFillPercent(this.skillAfterMatchNumeric1, high, low);
    },
    skillBarLinearWidthPercent2() {
      const { low, high } = this.matchSkillBarRange;
      return linearSkillBarFillPercent(this.skillAfterMatchNumeric2, high, low);
    },
    skillDeltaForWrestler1() {
      if (!this.match || typeof this.match.SkillChange !== "number") {
        return null;
      }
      return this.match.SkillChange;
    },
    skillDeltaForWrestler2() {
      if (typeof this.skillChangeWrestler2 !== "number") {
        return null;
      }
      return this.skillChangeWrestler2;
    },
  },
  watch: {
    "$route.params.matchID"() {
      this.getMatch();
    },
    "editForm.MatchDateString"(s) {
      if (!this.editDialog) return;
      const t = (s || "").trim();
      if (!t) {
        this.editForm.Season = "";
        return;
      }
      const d = new Date(t + "T12:00:00");
      if (!Number.isNaN(d.getTime())) {
        this.editForm.Season = seasonLabelFromMatchDate(d) || "";
      }
    },
  },
  mounted() {
    this.getMatch();
  },
  methods: {
    displaySeason(raw) {
      const n = normalizeSeasonToShort(String(raw || "").trim());
      return n || String(raw || "").trim() || "";
    },
    parseSkillNumber(raw) {
      if (raw == null || raw === "") return 1200;
      const n = typeof raw === "number" ? raw : Number(raw);
      if (Number.isFinite(n)) return n;
      return 1200;
    },
    formatMatchDate(matchDate) {
      if (!matchDate) return "—";
      try {
        const d =
          typeof matchDate.toDate === "function"
            ? matchDate.toDate()
            : matchDate;
        return this.$moment(d).format("MMMM Do, YYYY");
      } catch (_e) {
        return "—";
      }
    },
    formatAuditDate(d) {
      if (!d) return "";
      try {
        const val =
          typeof d.toDate === "function"
            ? d.toDate()
            : d instanceof Date
            ? d
            : new Date(d);
        return this.$moment(val).format("MMM D, YYYY h:mm a");
      } catch (_e) {
        return "";
      }
    },
    getActionColor(action) {
      switch (action) {
        case "create":
          return "#4CAF50";
        case "update":
          return "#FF9800";
        case "delete":
          return "#F44336";
        default:
          return "#9E9E9E";
      }
    },
    getChangesPreview(changes) {
      if (!changes || typeof changes !== "object") return "";
      const fields = Object.keys(changes).slice(0, 2);
      return fields.map((f) => `${f}`).join(", ");
    },
    normalizeVideoUrl(url) {
      const s = String(url || "").trim();
      if (!s) return "#";
      if (!/^https?:\/\//i.test(s)) return "https://" + s;
      return s;
    },
    formatSkillDelta(n) {
      return formatSkillDeltaPoints(n);
    },
    skillDeltaClass(delta) {
      if (delta == null || typeof delta !== "number") return {};
      if (delta > 0) return { "skill-gain": true };
      if (delta < 0) return { "skill-loss": true };
      return { "skill-neutral": true };
    },
    loadOpponentMatchSkillChange() {
      this.skillChangeWrestler2 = null;
      this.opponentMatchDocId = null;
      const wrestlerID = this.$route.params.wrestlerID;
      const matchID = this.$route.params.matchID;
      const raw = this.canonicalRaw;
      if (!raw || !wrestlerID || !matchID) return;
      const w = raw.WinnerAthleteId;
      const l = raw.LoserAthleteId;
      if (wrestlerID === w) {
        const sc = raw.SkillChangeLoser;
        if (typeof sc === "number") this.skillChangeWrestler2 = sc;
      } else if (wrestlerID === l) {
        const sc = raw.SkillChangeWinner;
        if (typeof sc === "number") this.skillChangeWrestler2 = sc;
      }
      this.opponentMatchDocId = matchID;
    },
    matchDateTs(matchDate) {
      if (!matchDate) return 0;
      try {
        if (typeof matchDate.toDate === "function") {
          return matchDate.toDate().getTime();
        }
        if (matchDate instanceof Date) return matchDate.getTime();
        if (matchDate.seconds != null) return matchDate.seconds * 1000;
        return new Date(matchDate).getTime();
      } catch (_e) {
        return 0;
      }
    },
    skillAfterIncludingMatch(matchRows, targetDocId) {
      if (!targetDocId || !matchRows || matchRows.length === 0) {
        return null;
      }
      const sorted = [...matchRows].sort((a, b) => {
        const ta = this.matchDateTs(a.MatchDate);
        const tb = this.matchDateTs(b.MatchDate);
        if (ta !== tb) return ta - tb;
        return String(a.id).localeCompare(String(b.id));
      });
      const hasDeltaData = sorted.some(
        (m) => typeof m.SkillChange === "number" && m.SkillChange !== 0
      );
      // All zeros / missing deltas: replay stays at 1200 — use current athlete Skill instead (see displaySkillAfterMatch*)
      if (!hasDeltaData) {
        return null;
      }
      let skill = 1200;
      for (const m of sorted) {
        const ch = typeof m.SkillChange === "number" ? m.SkillChange : 0;
        skill += ch;
        if (m.id === targetDocId) {
          return Math.round(skill * 100) / 100;
        }
      }
      return null;
    },
    async loadMatchLeagueSkillBounds() {
      this.matchLeagueSkillMin = null;
      this.matchLeagueSkillMax = null;
      const w1 = this.wrestler1;
      const w2 = this.wrestler2;
      if (!w1 && !w2) return;
      const db = getFirestore();
      const league1 =
        w1 && w1.RankLeague != null ? String(w1.RankLeague).trim() : "";
      const league2 =
        w2 && w2.RankLeague != null ? String(w2.RankLeague).trim() : "";
      try {
        if (league1 && league1 === league2) {
          const r = await fetchLeagueSkillMinMax(db, league1);
          this.matchLeagueSkillMin = r.min;
          this.matchLeagueSkillMax = r.max;
          return;
        }
        const [r1, r2] = await Promise.all([
          league1
            ? fetchLeagueSkillMinMax(db, league1)
            : Promise.resolve({ min: null, max: null }),
          league2
            ? fetchLeagueSkillMinMax(db, league2)
            : Promise.resolve({ min: null, max: null }),
        ]);
        const lows = [];
        const highs = [];
        [r1, r2].forEach((r) => {
          if (
            r &&
            r.min != null &&
            r.max != null &&
            Number.isFinite(r.min) &&
            Number.isFinite(r.max)
          ) {
            lows.push(r.min);
            highs.push(r.max);
          }
        });
        if (lows.length) {
          this.matchLeagueSkillMin = Math.min(...lows);
          this.matchLeagueSkillMax = Math.max(...highs);
        }
      } catch (_e) {
        this.matchLeagueSkillMin = null;
        this.matchLeagueSkillMax = null;
      }
    },
    async computeSkillRatingsAfterMatch() {
      this.skillRatingAfterMatch1 = null;
      this.skillRatingAfterMatch2 = null;
      const wrestlerID = this.$route.params.wrestlerID;
      const matchID = this.$route.params.matchID;
      if (!this.match || !wrestlerID || !matchID) return;
      const opponentID = this.match.WrestlerID;
      const db = getFirestore();
      try {
        const list1 = await fetchPerspectiveMatchesChronological(
          db,
          wrestlerID
        );
        this.skillRatingAfterMatch1 = this.skillAfterIncludingMatch(
          list1,
          matchID
        );
        if (opponentID) {
          const list2 = await fetchPerspectiveMatchesChronological(
            db,
            opponentID
          );
          this.skillRatingAfterMatch2 = this.skillAfterIncludingMatch(
            list2,
            matchID
          );
        }
      } catch (_e) {
        this.skillRatingAfterMatch1 = null;
        this.skillRatingAfterMatch2 = null;
      }
    },
    LoadWrestler(id) {
      this.$router.push("/wrestler/" + id);
    },
    goBack() {
      this.$router.go(-1);
    },
    logOff() {
      const auth = getAuth();
      signOut(auth).then(
        () => {},
        () => {}
      );
    },
    openEdit() {
      if (!this.match) return;
      this.editForm.Location = this.match.Location || "";
      this.editForm.Type = this.match.Type || "";
      try {
        const d =
          this.match.MatchDate &&
          typeof this.match.MatchDate.toDate === "function"
            ? this.match.MatchDate.toDate()
            : this.match.MatchDate;
        const asDate =
          d && !Number.isNaN(new Date(d).getTime()) ? new Date(d) : null;
        this.editForm.MatchDateString = asDate
          ? this.$moment(asDate).format("YYYY-MM-DD")
          : "";
        this.editForm.Season = asDate
          ? seasonLabelFromMatchDate(asDate) || ""
          : "";
      } catch (_e) {
        this.editForm.MatchDateString = "";
        this.editForm.Season = "";
      }
      this.editForm.VideoLink = this.match.VideoLink || "";
      this.editDialog = true;
    },
    async getMatch() {
      const wrestlerID = this.$route.params.wrestlerID;
      const matchID = this.$route.params.matchID;
      if (!wrestlerID || !matchID) {
        this.loading = false;
        return;
      }
      this.loading = true;
      this.match = null;
      this.wrestler1 = null;
      this.wrestler2 = null;
      this.skillChangeWrestler2 = null;
      this.opponentMatchDocId = null;
      this.skillRatingAfterMatch1 = null;
      this.skillRatingAfterMatch2 = null;
      this.matchLeagueSkillMin = null;
      this.matchLeagueSkillMax = null;
      this.canonicalRaw = null;
      const db = getFirestore();
      try {
        const matchRef = doc(db, MATCHES_CANONICAL_COLLECTION, matchID);
        const matchSnap = await getDoc(matchRef);
        if (matchSnap.exists()) {
          const raw = matchSnap.data() || {};
          this.canonicalRaw = raw;
          const perspective = perspectiveFromCanonical(raw, wrestlerID);
          if (perspective) {
            this.match = perspective;
            await this.getWrestler1();
            await this.getWrestler2();
            if (this.wrestler2 && this.wrestler2.Image) {
              this.match = {
                ...this.match,
                OpponentImage: this.wrestler2.Image || "",
              };
            }
            this.loadOpponentMatchSkillChange();
            await this.computeSkillRatingsAfterMatch();
            await this.loadMatchLeagueSkillBounds();
            if (this.authenticated) await this.loadAudits();
          } else {
            this.match = null;
          }
        }
      } catch (_err) {
        // Match load failed; loading state cleared below
      } finally {
        this.loading = false;
      }
    },
    async getWrestler1() {
      const wrestlerID = this.$route.params.wrestlerID;
      if (!wrestlerID) return;
      const db = getFirestore();
      try {
        const ref = doc(db, "athletes", wrestlerID);
        const snap = await getDoc(ref);
        if (snap.exists()) this.wrestler1 = snap.data();
      } catch (_err) {
        // Wrestler1 load failed
      }
    },
    async getWrestler2() {
      if (!this.match || !this.match.WrestlerID) return;
      const db = getFirestore();
      try {
        const ref = doc(db, "athletes", this.match.WrestlerID);
        const snap = await getDoc(ref);
        if (snap.exists()) this.wrestler2 = snap.data();
      } catch (_err) {
        // Wrestler2 load failed
      }
    },
    async loadAudits() {
      if (!this.authenticated) {
        this.audits = [];
        return;
      }
      const matchID = this.$route.params.matchID;
      if (!matchID) {
        this.audits = [];
        return;
      }
      const db = getFirestore();
      try {
        const auditsRef = collection(db, "auditLogs");
        const qAud = query(
          auditsRef,
          where("entityType", "==", "match"),
          where("entityId", "==", matchID)
        );
        const snap = await getDocs(qAud);
        const rows = [];
        snap.forEach((docSnap) => {
          rows.push({ id: docSnap.id, ...docSnap.data() });
        });
        // Sort by timestamp in descending order (newest first)
        rows.sort((a, b) => {
          const timeA = a.timestamp
            ? typeof a.timestamp.toDate === "function"
              ? a.timestamp.toDate().getTime()
              : new Date(a.timestamp).getTime()
            : 0;
          const timeB = b.timestamp
            ? typeof b.timestamp.toDate === "function"
              ? b.timestamp.toDate().getTime()
              : new Date(b.timestamp).getTime()
            : 0;
          return timeB - timeA;
        });
        this.audits = rows;
      } catch (_err) {
        this.audits = [];
      }
    },
    async saveMatchEdits() {
      if (!this.match) {
        this.editDialog = false;
        return;
      }
      const wrestlerID = this.$route.params.wrestlerID;
      const matchID = this.$route.params.matchID;
      if (!wrestlerID || !matchID) {
        this.editDialog = false;
        return;
      }
      const db = getFirestore();
      try {
        const matchRef = doc(db, MATCHES_CANONICAL_COLLECTION, matchID);
        const snap = await getDoc(matchRef);
        if (!snap.exists()) {
          this.editDialog = false;
          return;
        }
        const oldRaw = snap.data() || {};
        const oldPerspective = perspectiveFromCanonical(oldRaw, wrestlerID);
        const winnerId = oldRaw.WinnerAthleteId;
        const loserId = oldRaw.LoserAthleteId;
        const opponentID =
          wrestlerID === winnerId ? loserId : wrestlerID === loserId ? winnerId : null;

        await saveRankingsSnapshotForAthletes(
          db,
          [wrestlerID, opponentID].filter(Boolean)
        ).catch(() => {});

        let newMatchDateFs = oldRaw.MatchDate;
        if (this.editForm.MatchDateString) {
          const nd = new Date(this.editForm.MatchDateString + "T12:00:00");
          if (!Number.isNaN(nd.getTime())) {
            newMatchDateFs = Timestamp.fromDate(nd);
          }
        }
        const updatedType = this.editForm.Type || oldRaw.Type || "";
        const seasonFromDate =
          newMatchDateFs && typeof newMatchDateFs.toDate === "function"
            ? seasonLabelFromMatchDate(newMatchDateFs.toDate()) || ""
            : "";
        const updated = {
          Location: this.editForm.Location || "",
          Type: updatedType,
          MatchDate: newMatchDateFs,
          VideoLink: this.editForm.VideoLink || "",
          Season: seasonFromDate,
        };

        const typeChanged =
          String(oldRaw.Type || "") !== String(updated.Type || "");
        const dateChanged =
          matchDateMillis(oldRaw.MatchDate) !== matchDateMillis(newMatchDateFs);
        const idMustChange = typeChanged || dateChanged;

        let newMatchId = matchID;
        if (!idMustChange) {
          await updateDoc(matchRef, updated);
        } else {
          const newId = await computeCanonicalMatchDocId(
            winnerId,
            loserId,
            newMatchDateFs,
            updated.Type
          );
          if (newId === matchID) {
            await updateDoc(matchRef, updated);
          } else {
            const dupSnap = await getDoc(
              doc(db, MATCHES_CANONICAL_COLLECTION, newId)
            );
            if (dupSnap.exists()) {
              this.$root.$emit(
                "toast",
                "A match with this date and type already exists for these wrestlers.",
                "error"
              );
              return;
            }
            const merged = {
              ...oldRaw,
              ...updated,
              ParticipantAthleteIds: participantAthleteIds(winnerId, loserId),
            };
            await setDoc(doc(db, MATCHES_CANONICAL_COLLECTION, newId), merged);
            await deleteDoc(matchRef);
            newMatchId = newId;
            await this.$router.replace({
              path: `/wrestler/${wrestlerID}/match/${newId}`,
            });
          }
        }

        const recalcWl = async (id) => {
          const { wins, losses } = await countWinsLossesFromCanonical(db, id);
          await updateDoc(doc(db, "athletes", id), { Wins: wins, Losses: losses });
        };
        await recalcWl(wrestlerID);
        if (opponentID) await recalcWl(opponentID);

        if (typeChanged) {
          await this.markAthletesForRecalc(wrestlerID, opponentID);
        }

        const auth = getAuth();
        const user = auth.currentUser;
        const changes = {};
        if (oldPerspective && oldPerspective.Type !== updated.Type) {
          changes.Type = { old: oldPerspective.Type || "", new: updated.Type };
        }
        if (oldPerspective && oldPerspective.Location !== updated.Location) {
          changes.Location = {
            old: oldPerspective.Location || "",
            new: updated.Location,
          };
        }
        if (
          oldPerspective &&
          String(oldPerspective.MatchDate || "") !==
            String(updated.MatchDate || "")
        ) {
          changes.MatchDate = {
            old: oldPerspective.MatchDate || "",
            new: updated.MatchDate,
          };
        }
        if (oldPerspective && oldPerspective.VideoLink !== updated.VideoLink) {
          changes.VideoLink = {
            old: oldPerspective.VideoLink || "",
            new: updated.VideoLink,
          };
        }
        if (oldPerspective && oldPerspective.Season !== updated.Season) {
          changes.Season = {
            old: oldPerspective.Season || "",
            new: updated.Season,
          };
        }

        if (Object.keys(changes).length > 0) {
          await logAuditEntry(
            "match",
            newMatchId,
            "update",
            changes,
            user ? user.uid : "system",
            user ? user.displayName || user.email : "System"
          );
        }

        const refreshed = await getDoc(
          doc(db, MATCHES_CANONICAL_COLLECTION, newMatchId)
        );
        if (refreshed.exists()) {
          this.canonicalRaw = refreshed.data() || {};
          const perspective = perspectiveFromCanonical(
            this.canonicalRaw,
            wrestlerID
          );
          this.match = perspective || this.match;
          await this.getWrestler2();
          if (this.wrestler2 && this.wrestler2.Image) {
            this.match = {
              ...this.match,
              OpponentImage: this.wrestler2.Image || "",
            };
          }
          this.loadOpponentMatchSkillChange();
          await this.computeSkillRatingsAfterMatch();
        }

        if (this.authenticated) await this.loadAudits();
        this.editDialog = false;
        this.$root.$emit("toast", "Match updated successfully", "success");
        if (oldPerspective && oldPerspective.Season !== updated.Season) {
          this.$root.$emit("rankster-seasons-changed");
        }
      } catch (_err) {
        const msg =
          _err && _err.message ? _err.message : "Failed to update match.";
        this.$root.$emit("toast", msg, "error");
        this.editDialog = false;
      }
    },
    openDeleteDialog() {
      this.deleteDialog = true;
    },
    async deleteMatch() {
      const wrestlerID = this.$route.params.wrestlerID;
      const matchID = this.$route.params.matchID;
      if (!wrestlerID || !matchID) {
        this.deleteDialog = false;
        return;
      }
      const db = getFirestore();
      try {
        const matchRef = doc(db, MATCHES_CANONICAL_COLLECTION, matchID);
        const snap = await getDoc(matchRef);
        if (!snap.exists()) {
          this.deleteDialog = false;
          return;
        }
        const raw = snap.data() || {};
        const winnerId = raw.WinnerAthleteId;
        const loserId = raw.LoserAthleteId;
        const opponentID =
          wrestlerID === winnerId ? loserId : wrestlerID === loserId ? winnerId : null;
        const perspective = perspectiveFromCanonical(raw, wrestlerID);

        await saveRankingsSnapshotForAthletes(
          db,
          [wrestlerID, opponentID].filter(Boolean)
        ).catch(() => {});

        const scW =
          typeof raw.SkillChangeWinner === "number" ? raw.SkillChangeWinner : 0;
        const scL =
          typeof raw.SkillChangeLoser === "number" ? raw.SkillChangeLoser : 0;
        const skillChangeForWrestler1 =
          wrestlerID === winnerId ? scW : wrestlerID === loserId ? scL : 0;
        const skillChangeForWrestler2 =
          opponentID === winnerId ? scW : opponentID === loserId ? scL : 0;

        const wrestler1Ref = doc(db, "athletes", wrestlerID);
        const wrestler1Snap = await getDoc(wrestler1Ref);
        const wrestler1Data = wrestler1Snap.exists()
          ? wrestler1Snap.data()
          : {};
        const currentSkill1 = wrestler1Data.Skill || 1200;

        let currentSkill2 = 1200;
        let wrestler2Ref = null;
        if (opponentID) {
          wrestler2Ref = doc(db, "athletes", opponentID);
          const wrestler2Snap = await getDoc(wrestler2Ref);
          const wrestler2Data = wrestler2Snap.exists()
            ? wrestler2Snap.data()
            : {};
          currentSkill2 = wrestler2Data.Skill || 1200;
        }

        const newSkill1 = Math.max(1, currentSkill1 - skillChangeForWrestler1);
        const newSkill2 = Math.max(1, currentSkill2 - skillChangeForWrestler2);

        await deleteDoc(matchRef);

        await updateDoc(wrestler1Ref, { Skill: newSkill1 });
        if (opponentID && wrestler2Ref) {
          await updateDoc(wrestler2Ref, { Skill: newSkill2 });
        }

        const recalcWl = async (id) => {
          const { wins, losses } = await countWinsLossesFromCanonical(db, id);
          await updateDoc(doc(db, "athletes", id), { Wins: wins, Losses: losses });
        };
        await recalcWl(wrestlerID);
        if (opponentID) await recalcWl(opponentID);

        await this.markAthletesForRecalc(wrestlerID, opponentID);

        const auth = getAuth();
        const user = auth.currentUser;
        await logAuditEntry(
          "match",
          matchID,
          "delete",
          {
            Type: { old: (perspective && perspective.Type) || "", new: null },
            MatchDate: {
              old: (perspective && perspective.MatchDate) || "",
              new: null,
            },
            Result: { old: (perspective && perspective.Result) || "", new: null },
            SkillChange: { old: skillChangeForWrestler1, new: null },
          },
          user ? user.uid : "system",
          user ? user.displayName || user.email : "System"
        );

        this.deleteDialog = false;
        this.$root.$emit("toast", "Match deleted successfully", "success");
        this.$root.$emit("rankster-seasons-changed");
        this.$router.push("/wrestler/" + wrestlerID);
      } catch (_err) {
        const msg =
          _err && _err.message ? _err.message : "Failed to delete match.";
        this.$root.$emit("toast", msg, "error");
        this.deleteDialog = false;
      }
    },
  },
};
</script>

<style scoped>
.match-video-link {
  color: #1976d2;
  text-decoration: none;
  word-break: break-all;
}
.match-video-link:hover {
  text-decoration: underline;
}
.skill-gain {
  color: #059669;
  font-weight: bold;
}
.skill-loss {
  color: #dc2626;
  font-weight: bold;
}
.skill-neutral {
  color: #64748b;
  font-weight: 700;
}
.theme--dark .skill-neutral {
  color: #94a3b8;
}
.match-skill-pair {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.35rem 0.5rem;
}
.match-skill-pair-item {
  min-width: 0;
}
.match-skill-pair-sep {
  color: rgba(0, 0, 0, 0.35);
  user-select: none;
}
.theme--dark .match-skill-pair-sep {
  color: rgba(255, 255, 255, 0.5);
}
.match-detail-row--skill .match-detail-value {
  font-size: 0.875rem;
}

/* Match results layout – responsive */
.match-results-page {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding-bottom: 1rem;
}
.match-results-card {
  overflow: hidden;
}
.match-results-toolbar {
  flex-shrink: 0;
}
.match-results-title {
  font-size: 1rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.match-wrestlers {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.75rem 1.25rem;
  padding: 1.25rem 1rem;
  min-height: 100px;
}
.match-wrestler {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  border: none;
  border-radius: 12px;
  background: transparent;
  cursor: pointer;
  transition: background 0.2s, transform 0.15s;
  min-width: 0;
}
.match-wrestler:hover {
  background: rgba(0, 0, 0, 0.06);
}
.match-wrestler:active {
  transform: scale(0.98);
}
.theme--dark .match-wrestler:hover {
  background: rgba(255, 255, 255, 0.08);
}
.match-wrestler-avatar {
  flex-shrink: 0;
}
.match-wrestler-name {
  font-size: 0.95rem;
  font-weight: 600;
  text-align: center;
  line-height: 1.3;
  word-break: break-word;
  max-width: 120px;
}
.match-wrestler-rating {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.2rem;
  margin-top: 0.15rem;
  width: 100%;
  max-width: 168px;
}

/* Linear skill bar: global max scale (same idea as Wrestler profile) */
.skill-bar.skill-bar--match {
  min-width: 120px;
  max-width: 168px;
  width: 100%;
  position: relative;
}
.skill-bar--match.skill-bar--linear .skill-bar-linear-track {
  height: 12px;
  border-radius: 999px;
  background: #e5e7eb;
  overflow: hidden;
}
.skill-bar--match.skill-bar--linear .skill-bar-linear-fill {
  height: 100%;
  border-radius: 999px;
  min-width: 0;
  background: linear-gradient(
    90deg,
    #22c55e 0%,
    #a3e635 22%,
    #facc15 48%,
    #f97316 74%,
    #b91c1c 100%
  );
  transition: width 0.25s ease;
}
.skill-bar--match .skill-bar-label {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 0.7rem;
  font-weight: 600;
  color: #111827;
  text-shadow: none;
  pointer-events: none;
}
.theme--dark .skill-bar--match.skill-bar--linear .skill-bar-linear-track {
  background: #374151;
}
.theme--dark .skill-bar--match .skill-bar-label {
  color: #f3f4f6;
}
.match-vs {
  font-size: 0.875rem;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.45);
  flex-shrink: 0;
}
.theme--dark .match-vs {
  color: rgba(255, 255, 255, 0.5);
}
.match-details-card {
  overflow: hidden;
}
.match-details-inner {
  padding: 0.5rem 1rem 1rem;
}
.match-detail-row {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.35rem 1rem;
  padding: 0.65rem 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.match-detail-row:last-child {
  border-bottom: none;
}
.theme--dark .match-detail-row {
  border-bottom-color: rgba(255, 255, 255, 0.08);
}
.match-detail-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.6);
  min-width: 100px;
  flex-shrink: 0;
}
.theme--dark .match-detail-label {
  color: rgba(255, 255, 255, 0.65);
}
.match-detail-value {
  font-size: 0.9375rem;
  flex: 1;
  min-width: 0;
  word-break: break-word;
}
@media (max-width: 600px) {
  .match-wrestlers {
    flex-direction: column;
    padding: 1rem 0.75rem;
    gap: 0.5rem;
  }
  .match-wrestler-name {
    max-width: 140px;
  }
  .match-detail-row {
    flex-direction: column;
    gap: 0.15rem;
    padding: 0.75rem 0;
  }
  .match-detail-label {
    min-width: 0;
    font-size: 0.8125rem;
  }
  .match-details-inner {
    padding: 0.5rem 0.75rem 0.75rem;
  }
}
.match-history-card {
  overflow: hidden;
}
.match-history-header {
  padding: 0.75rem 1rem;
  font-size: 0.9375rem;
  font-weight: 600;
  background: rgba(0, 0, 0, 0.04);
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.theme--dark .match-history-header {
  background: rgba(255, 255, 255, 0.06);
  border-bottom-color: rgba(255, 255, 255, 0.08);
}
.match-history-body {
  padding: 0.5rem 0;
}
.match-history-item {
  padding: 0.6rem 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.match-history-item:last-child {
  border-bottom: none;
}
.theme--dark .match-history-item {
  border-bottom-color: rgba(255, 255, 255, 0.06);
}
.match-history-item-title {
  font-size: 0.9rem;
  font-weight: 500;
  margin-bottom: 0.2rem;
}
.match-history-chip {
  margin-right: 0.35rem;
}
.match-history-item-subtitle {
  font-size: 0.8125rem;
  color: rgba(0, 0, 0, 0.6);
}
.theme--dark .match-history-item-subtitle {
  color: rgba(255, 255, 255, 0.6);
}
.match-history-changes {
  margin-left: 0.35rem;
  font-weight: 600;
}
.match-history-empty {
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.5);
}
.theme--dark .match-history-empty {
  color: rgba(255, 255, 255, 0.5);
}

/* Edit match dialog – match Edit Wrestler UI */
.edit-match-card {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}
.edit-match-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  background: linear-gradient(135deg, #c62828 0%, #b71c1c 100%);
  color: #fff;
}
.edit-match-title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  letter-spacing: -0.02em;
}
.edit-match-close {
  margin: 0;
  opacity: 0.8;
  transition: opacity 0.2s;
}
.edit-match-close:hover {
  opacity: 1;
}
.edit-match-body {
  padding: 1.5rem;
}
.edit-match-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.edit-match-form .form-row {
  width: 100%;
}
.edit-match-form .form-row-split {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.25rem;
}
.edit-match-form .form-row-cell {
  min-width: 0;
}
.edit-match-form .form-field {
  width: 100%;
}
.edit-match-actions {
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.75rem;
  border-top: 1px solid #e5e7eb;
  background: #f9fafb;
}
.edit-match-actions .action-btn {
  min-height: 40px;
  min-width: 100px;
  font-size: 0.95rem;
  border-radius: 4px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.edit-match-actions .action-cancel {
  color: #374151;
  border: 1px solid #d1d5db;
  background: white;
}
.edit-match-actions .action-cancel:hover {
  background: #f9fafb;
  border-color: #9ca3af;
}
.edit-match-actions .action-save {
  background: #2563eb;
  color: white;
}
.edit-match-actions .action-save:hover {
  background: #1d4ed8;
}
@media (max-width: 768px) {
  .edit-match-header {
    padding: 0.75rem 1rem;
  }
  .edit-match-title {
    font-size: 1rem;
  }
  .edit-match-body {
    padding: 1rem;
  }
  .edit-match-form {
    gap: 1rem;
  }
  .edit-match-form .form-row-split {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  .edit-match-actions {
    padding: 0.75rem 1rem;
    flex-direction: column-reverse;
  }
  .edit-match-actions .action-btn {
    width: 100%;
    min-width: auto;
  }
}
</style>

<style>
/* Edit match dialog – input styling to match Edit Wrestler */
.edit-match-dialog .v-input {
  margin-bottom: 0;
}
.edit-match-dialog .v-input__control {
  min-height: auto;
}
.edit-match-dialog .v-text-field__details,
.edit-match-dialog .v-select__details {
  display: none;
}
.edit-match-dialog .v-messages {
  min-height: 0;
  display: none;
}
.edit-match-dialog .v-input__slot {
  padding: 8px 12px;
  min-height: 44px;
}
</style>
